module.exports = __webpack_public_path__ + "img/loginLeft.9a8c955d.svg";